import { Box, ListItem, Typography } from "@mui/material";
import { Virtuoso } from "react-virtuoso";
import LoadingSpinner from "../../../common/components/functional/loadingSpinner/LoadingSpinner";
import { Conversation } from "../types/queries";
import InboxRow from "./InboxRow";

type Props = {
  conversations: Conversation[];
  loading: boolean;
  loadingMore: boolean;
  loadMore: () => void;
  onConversationChange: (conversation: Conversation) => void;
  emptyLabel?: string;
};

const InboxConversationList = ({
  conversations,
  loading,
  loadingMore,
  loadMore,
  onConversationChange,
  emptyLabel,
}: Props) => (
  <Virtuoso
    style={{ height: "100%", width: "100%", overflowX: "hidden" }}
    data={conversations}
    endReached={loadMore}
    itemContent={(_index, conversation) => (
      <InboxRow
        conversation={conversation}
        onConversationChange={onConversationChange}
      />
    )}
    components={{
      Footer: () => {
        if (loadingMore) {
          return (
            <ListItem sx={{ height: "79px" }}>
              <LoadingSpinner size={24} />
            </ListItem>
          );
        }
        return null;
      },
      EmptyPlaceholder: () => {
        if (loading) return <LoadingSpinner />;
        if (!emptyLabel) return null;
        return (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              padding: "24px 16px",
            }}
          >
            <Typography variant="body2" color="text.secondary" align="center">
              {emptyLabel}
            </Typography>
          </Box>
        );
      },
    }}
  />
);

export default InboxConversationList;
